<template>
  <div class="statistical-report-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>

      <el-button type="primary" size="small" @click="getUserTody('status')"
        >搜索</el-button
      >
    </div>
    <!--表格数据-->
    <el-table
      max-height="650"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="date"
        label="日期"
        align="center"
        width="180"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.date | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="visitUserCount"
        label="今日活跃用户"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.visitUserCount * 4.2 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="newUserCount"
        label="新增用户数"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.newUserCount * 2.6 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bindUserCount"
        label="绑定用户数"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.bindUserCount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="newBindUserCount"
        label="新增绑定用户数"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.newBindUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate2Day"
        label="次日留存率"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate2Day || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate7Day"
        label="7日留存率"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate7Day || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate30Day"
        label="30日留存率"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate30Day || "未知" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import { changeTime } from "@/utils/global";
import API from "@/api";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      // 时间数据绑定字段
      time: "",
      tableData: [],
      total: 0,
      // 表格数据加载动画
      loading: false,
      // 用户今日统计列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
      },
    };
  },
  computed: {
    //映射模拟倍率
    ...mapGetters(["expansionFactor"]),
  },
  created() {
    this.getUserTody();
  },
  methods: {
    //映射模拟倍率方法
    ...mapActions(["setBeilv"]),
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || null;
        this.params.endTime = changeTime(time[1]) || null;
      } else {
        this.params.startTime = null;
        this.params.endTime = null;
      }
      this.getUserTody("status");
    },
    // 请求用户今日统计列表数据
    getUserTody(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getUserTody({ ...this.params, expansionFactor: this.expansionFactor })
        .then((res) => {
          this.loading = false;
          this.setBeilv(this.expansionFactor);
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getUserTody();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getUserTody();
    },
  },
};
</script>
